import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import { IChunkModel } from '@common/models/Chunks/Chunk';

import LessonsLinkItem from './Item';
import { StyledLessonLinkList } from './styled';

interface PropsType {
	files: IChunkModel[];
}

function LinkSectionFiles({ files }: PropsType) {
	const { t } = useTranslation();
	if (!files || files?.length <= 0) return null;

	return (
		<>
			<Typography variant="subtitle2">{t('lesson.files')}</Typography>
			<StyledLessonLinkList>
				{files
					.filter((file) => !!file.file_url)
					.map((file) => (
						<LessonsLinkItem
							key={file.id}
							title={file.name}
							href={file.file_url}
							download={file.file?.original_name}
						/>
					))}
			</StyledLessonLinkList>
		</>
	);
}

export default LinkSectionFiles;
